module.exports = __webpack_public_path__ + "img/np_pin.73c74f64.svg";